export interface ISessionLike {
  email?: string | null;
  roles?: string[];
  settings?: Record<string, any>;
}

/**
 * True when the vendored session belongs to a real, signed-in user.
 *
 * EMX2 hands out a session for everyone: a visitor who never signed in gets
 * `email: "anonymous"`, which is what the vendored MolgenisSession component
 * itself tests for before it shows "Hi <email>" / "Sign out" instead of the
 * Sign up / Sign in buttons. The same test drives the `hide-navbar-session`
 * body class in App.vue, so keep it in step with the vendored component.
 */
export function isSignedIn(session?: ISessionLike | null): boolean {
  const email = session?.email;
  return typeof email === "string" && email !== "" && email !== "anonymous";
}

/**
 * True when the deployment delegates sign-in to an OIDC provider, in which
 * case there is no password form to show - MolgenisSession links to `/_login`
 * instead, and so does AdminSignIn.vue.
 */
export function isOidcEnabled(session?: ISessionLike | null): boolean {
  return session?.settings?.isOidcEnabled === "true";
}

/**
 * The vendored OIDC entry point, which returns the user to `currentUrl` once
 * the provider is done. Mirrors MolgenisSession's `oidcLoginUrl`.
 */
export function oidcLoginUrl(currentUrl?: string): string {
  const redirect = currentUrl
    ? `?redirect=${encodeURIComponent(currentUrl)}`
    : "";
  return `/_login${redirect}`;
}
